import React from 'react'
import { ModalSeeker, TextFieldSeeker, ButtonLoadingSeeker } from '@ui-seeker/core'
import { Grid, Divider } from '@mui/material'
import { useSignal } from '@preact/signals-react'
import { BIOpenUrlModal } from 'Pages/BusinessLogistics/BI/Page/@signals'
import { useBIUrlModalSubmit } from 'Pages/BusinessLogistics/BI/Page/@hooks'


export default function BIUrlModal() {

	const urlName = useSignal('')
	const { isLoading, setIsLoading } = useBIUrlModalSubmit(urlName.value)


	return <ModalSeeker
		hideActions
		isOpen={!!BIOpenUrlModal.value}
		title={'Url name '}
		containerProps={{ maxWidth: 'sm', p: 2 }}
		controller={() => BIOpenUrlModal.value = null}
	>
		<Grid container spacing={1}>
			<Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<TextFieldSeeker
					label="Custom Name for the Url"
					value={urlName.value}
					onChange={e => urlName.value = e.target.value}
				/>
			</Grid>
			<Grid item xs={12}>
				<Divider sx={{ width: '100%', my: 2 }}/>
			</Grid>
			<Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<ButtonLoadingSeeker
					loading={isLoading}
					onClick={setIsLoading}
				>
					Confirm
				</ButtonLoadingSeeker>
			</Grid>
			<Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<ButtonLoadingSeeker
					onClick={() => BIOpenUrlModal.value = false}
				>
					Cancel
				</ButtonLoadingSeeker>
			</Grid>
		</Grid>
	</ModalSeeker>
}